import { render } from "./patient-register-step2.vue?vue&type=template&id=5a785f62"
import script from "./patient-register-step2.vue?vue&type=script&lang=js"
export * from "./patient-register-step2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__